import React from 'react';
import { useSelector } from 'react-redux';
import errImage from '../assets/images/error.svg';
import Content from './Content.js';
import ErrorBoundary from './ErrorBoundary.js';
import PageBase from './PageBase.js';
import TopNav from './TopNav/index.js';
export const ErrorPage = () => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(TopNav, null),
        React.createElement(Content, null,
            React.createElement(PageBase, null,
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: 'calc(100vh - 120px)',
                    } },
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                            maxWidth: '600px',
                        } },
                        React.createElement("img", { style: { maxWidth: '100%' }, src: errImage }),
                        React.createElement("h1", { style: {} }, lang.misc.errorOccured)))))));
};
export const AsyncComponent = (Loader, Error, fetcher, reportError) => class AsyncComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            success: false,
            component: undefined,
            error: undefined,
        };
    }
    UNSAFE_componentWillMount() {
        fetcher()
            .then((component) => {
            this.setState({
                loading: false,
                success: true,
                component,
            });
        })
            .catch((err) => {
            this.setState({
                loading: false,
                error: err,
            });
        });
    }
    render() {
        return (
        // @ts-ignore
        React.createElement(ErrorBoundary, { fallback: React.createElement(ErrorPage, null), reportError: reportError }, this.state.loading
            ? React.createElement(Loader)
            : this.state.success
                ? React.createElement(this.state.component, this.props)
                : React.createElement(Error, { error: this.state.error })));
    }
};
export default AsyncComponent;
//# sourceMappingURL=AsyncComponent.js.map